import type { Quote } from '@client/model/quotesModel';

export type PaymentOption = 'Single Pay' | '10-Pay' | 'Monthly' | 'Annually';

export function getPaymentOptionFromQuote(quote: Quote): PaymentOption {
  if (quote.cobPaymentOption) {
    const normalized = quote.cobPaymentOption.toLowerCase();
    if (normalized.includes('single')) return 'Single Pay';
    if (normalized.includes('10') || normalized.includes('ten')) return '10-Pay';
    if (normalized.includes('monthly')) return 'Monthly';
    if (normalized.includes('annual')) return 'Annually';
  }

  if (quote.productFundingOption) {
    const normalized = quote.productFundingOption.toLowerCase();
    if (normalized.includes('single')) return 'Single Pay';
    if (normalized.includes('10') || normalized.includes('ten')) return '10-Pay';
    if (normalized.includes('monthly')) return 'Monthly';
    if (normalized.includes('annual')) return 'Annually';
  }

  return 'Single Pay';
}

